export const menuToggle = () => {
  const siteNav = document.getElementById("siteNav");
  const mainMenu = document.querySelector("#siteNav .navbar__nav");
  const toggleMenu = document.getElementById("toggleMenu");
  const header = document.getElementById("header");

  const ToggleMenu = () => {
    toggleMenu.classList.toggle("active");
    siteNav.classList.toggle("active");
    header.classList.toggle("menuIsOpen");
    mainMenu.classList.toggle("isOpen");
    document.querySelectorAll("html, body").forEach((el) => {
      el.classList.toggle("no-scroll");
    });
  };

  toggleMenu.addEventListener("click", ToggleMenu);

  const menuLinks = document.querySelectorAll(".menu-item a");
  menuLinks.forEach((item) => {
    item.addEventListener("click", (event) => {
      if (event.target.closest(".menu-item-has-children")) return;

      toggleMenu.classList.remove("active");
      siteNav.classList.remove("active");
      header.classList.remove("menuIsOpen");
      mainMenu.classList.remove("isOpen");
      document.querySelectorAll("html, body").forEach((el) => {
        el.classList.remove("no-scroll");
      });
    });
  });
};
